import { z } from "zod";
/** @see `projectFrameworkCreditCoverageSchema` in the entity. */
export const projectFrameworkCreditCoverageLineItemSchema = z.object({
    kind: z.string(),
    levelId: z.string(),
    sourceId: z.string()
});
/** @see `projectFrameworkCreditSchema` in the entity. */
export const projectFrameworkCreditLineItemSchema = z.object({
    /** @see the note on `projectFrameworkCreditSchema.coverage_sources`. */
    coverageSources: z
        .array(projectFrameworkCreditCoverageLineItemSchema)
        .optional(),
    creditCode: z.string(),
    levelId: z.string(),
    pursued: z.boolean()
});
/** @see `projectFrameworkDeclaredCreditSchema` in the entity. */
export const projectFrameworkDeclaredCreditLineItemSchema = z.object({
    creditCode: z.string(),
    /** The profile that last answered, if it still exists. */
    declaredBy: z.string().optional(),
    declaredPoints: z.number(),
    /** @see `minimum_expectation_met` in the entity. Absent is not answered. */
    minimumExpectationMet: z.boolean().optional(),
    /** @see `not_applicable_points` in the entity. Absent reads as 0. */
    notApplicablePoints: z.number().optional(),
    /** When it was last answered. */
    updated: z.date().optional()
});
export const projectFrameworkLineItemSchema = z.object({
    country: z.string(),
    created: z.date(),
    /** @see the note on `projectFrameworkSchema.credits`. */
    credits: z.array(projectFrameworkCreditLineItemSchema).optional(),
    /** @see the note on `projectFrameworkSchema.declared_credits`. */
    declaredCredits: z
        .array(projectFrameworkDeclaredCreditLineItemSchema)
        .optional(),
    /** @see the note on `projectFrameworkSchema.framework_abbreviation`. */
    frameworkAbbreviation: z.string().optional(),
    frameworkId: z.string(),
    frameworkName: z.string(),
    /** @see the note on `projectFrameworkSchema.framework_version`. */
    frameworkVersion: z.number().optional(),
    id: z.string(),
    projectId: z.string(),
    state: z.string().optional(),
    /** @see the note on `projectFrameworkSchema.targeted_rating`. */
    targetedRating: z.string().nullable().optional()
});
